// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"5c507267","457":"e354dfae","520":"18a59af2","811":"2fa7fd62"}[chunkId] + ".css";
};